export const BALANCE_OPERATIONS_CATEGORIES = [
  {
    id: "marketing_plan",
    name: "План вознаграждений",
  },
  {
    id: "transactions",
    name: "Транзакции",
  },
];
